import { echartSetOption } from './echarts-utils';

// dayjs.extend(advancedFormat);

/* -------------------------------------------------------------------------- */
/*                             Echarts Total Sales                            */
/* -------------------------------------------------------------------------- */

const echartsLeadConversiontInit = () => {
  const { getColor, getData, getPastDates, toggleColor } = window.phoenix.utils;
  const $leadConversionChartEl = document.querySelector(
    '.echart-lead-conversion'
  );

  const dates = getPastDates(4);

  const tooltipFormatter = params => {
    let tooltipItem = ``;
    params.forEach(el => {
      tooltipItem += `<h6 class="text-md text-subtle mb-0"><span class="fas fa-circle me-2" style="color:${el.color}"></span>
      ${el.axisValue} : ${el.value}
    </h6>`;
    });
    return `<div class='ms-1'>
              ${tooltipItem}
            </div>`;
  };

  if ($leadConversionChartEl) {
    const userOptions = getData($leadConversionChartEl, 'echarts');
    const chart = window.echarts.init($leadConversionChartEl);

    const getDefaultOptions = () => ({
      color: [
        getColor('color-primary'),
        getColor('background-color-highlight')
      ],
      tooltip: {
        trigger: 'axis',
        padding: [7, 10],
        backgroundColor: getColor('background-color-subtle'),
        borderColor: getColor('border-color-base'),
        textStyle: { color: getColor('text-color-emphasis') },
        borderWidth: 1,
        transitionDuration: 0,
        axisPointer: {
          type: 'none'
        },
        formatter: params => tooltipFormatter(params),
        extraCssText: 'z-index: 1000'
      },
      xAxis: {
        type: 'value',
        inverse: true,
        axisLabel: {
          show: false
        },
        show: false,
        data: dates,
        axisLine: {
          lineStyle: {
            color: getColor('background-color-highlight')
          }
        },
        axisTick: false
      },
      yAxis: {
        data: ['Closed Won', 'Objection', 'Offer', 'Qualify Lead', 'Created'],
        type: 'category',
        axisPointer: { type: 'none' },
        axisTick: 'none',
        splitLine: {
          interval: 5,
          lineStyle: {
            color: getColor('background-color-muted')
          }
        },
        axisLine: { show: false },
        axisLabel: {
          show: true,
          align: 'left',
          margin: 100,
          color: getColor('text-color-default')
        }
      },
      series: {
        name: 'Lead Conversion',
        type: 'bar',
        barWidth: '20px',
        showBackground: true,
        backgroundStyle: {
          borderRadius: [4, 0, 0, 4]
        },
        data: [
          {
            value: 1060,
            itemStyle: {
              color: toggleColor(
                getColor('color-success-lighter'),
                getColor('color-success-dark')
              ),
              borderRadius: [4, 0, 0, 4]
            },
            emphasis: {
              itemStyle: {
                color: toggleColor(
                  getColor('color-success-light'),
                  getColor('color-success-dark')
                )
              },
              label: {
                formatter: () => `{b| 53% }`,
                rich: {
                  b: {
                    color: getColor('color-white')
                  }
                }
              }
            },
            label: {
              show: true,
              position: 'inside',
              formatter: () => `{b| 53%}`,
              rich: {
                b: {
                  color: toggleColor(
                    getColor('color-success-dark'),
                    getColor('color-success-subtle')
                  ),
                  fontWeight: 500,
                  padding: [0, 5, 0, 0]
                }
              }
            }
          },
          // --
          {
            value: 1200,
            itemStyle: {
              color: toggleColor(
                getColor('color-info-lighter'),
                getColor('color-info-dark')
              ),
              borderRadius: [4, 0, 0, 4]
            },
            emphasis: {
              itemStyle: {
                color: toggleColor(
                  getColor('color-info-light'),
                  getColor('color-info-dark')
                )
              },
              label: {
                formatter: () => `{b| 60% }`,
                rich: {
                  b: {
                    color: getColor('color-white')
                  }
                }
              }
            },
            label: {
              show: true,
              position: 'inside',
              formatter: () => `{b| 60%}`,
              rich: {
                b: {
                  color: toggleColor(
                    getColor('color-info-dark'),
                    getColor('color-info-bg-subtle')
                  ),
                  fontWeight: 500,
                  padding: [0, 5, 0, 0]
                }
              }
            }
          },
          {
            value: 1600,
            itemStyle: {
              color: toggleColor(
                getColor('color-primary-lighter'),
                getColor('color-primary-dark')
              ),
              borderRadius: [4, 0, 0, 4]
            },
            emphasis: {
              itemStyle: {
                color: toggleColor(
                  getColor('color-primary-light'),
                  getColor('color-primary-dark')
                )
              },
              label: {
                formatter: () => `{b| 80% }`,
                rich: {
                  b: {
                    color: getColor('color-white')
                  }
                }
              }
            },
            label: {
              show: true,
              position: 'inside',
              formatter: () => `{b| 80% }`,
              rich: {
                b: {
                  color: toggleColor(
                    getColor('color-primary-dark'),
                    getColor('color-primary-bg-subtle')
                  ),
                  fontWeight: 500,
                  padding: [0, 5, 0, 0]
                }
              }
            }
          },
          {
            value: 1800,
            itemStyle: {
              color: toggleColor(
                getColor('color-warning-lighter'),
                getColor('color-warning-dark')
              ),
              borderRadius: [4, 0, 0, 4]
            },
            emphasis: {
              itemStyle: {
                color: toggleColor(
                  getColor('color-warning-light'),
                  getColor('color-warning-dark')
                )
              },
              label: {
                formatter: () => `{b| 90% }`,
                rich: {
                  b: {
                    color: getColor('color-white')
                  }
                }
              }
            },
            label: {
              show: true,
              position: 'inside',
              formatter: () => `{b|90%}`,
              rich: {
                b: {
                  color: toggleColor(
                    getColor('color-warning-dark'),
                    getColor('color-warning-bg-subtle')
                  ),
                  fontWeight: 500,
                  padding: [0, 5, 0, 0]
                }
              }
            }
          },
          {
            value: 2000,
            itemStyle: {
              color: toggleColor(
                getColor('color-danger-lighter'),
                getColor('color-danger-dark')
              ),
              borderRadius: [4, 0, 0, 4]
            },
            emphasis: {
              itemStyle: {
                color: toggleColor(
                  getColor('color-danger-light'),
                  getColor('color-danger-dark')
                )
              },
              label: {
                formatter: () => `{a|100%}`,
                rich: {
                  a: {
                    color: getColor('color-white')
                  }
                }
              }
            },
            label: {
              show: true,
              position: 'inside',
              formatter: () => `{a|100%}`,
              rich: {
                a: {
                  color: toggleColor(
                    getColor('color-danger-dark'),
                    getColor('color-danger-bg-subtle')
                  ),
                  fontWeight: 500
                }
              }
            }
          }
        ],
        barGap: '50%'
      },
      grid: {
        right: 5,
        left: 100,
        bottom: 0,
        top: '5%'
      },
      animation: false
    });

    const responsiveOptions = {
      xs: {
        yAxis: {
          show: false
        },
        grid: {
          left: 0
        }
      },
      sm: {
        yAxis: {
          show: true
        },
        grid: {
          left: 100,
          outerBoundsMode: 'none'
        }
      }
    };

    echartSetOption(chart, userOptions, getDefaultOptions, responsiveOptions);
  }
};

export default echartsLeadConversiontInit;
